module.exports = __webpack_public_path__ + "static/media/logo-apple-white.a8239aca.svg";